import React from 'react'
import PreOrPostSearch from './PreOrPostSearch'

const FooterItems = () => (
  <footer>
    <PreOrPostSearch />
  </footer>
)

export default FooterItems



// WEBPACK FOOTER //
// ./src/components/Elements/Footer/FooterItems.jsx